import React, { useState, useEffect } from "react";
import { useTranslation } from '../hooks/useTranslation';
import LanguageSelector from '../components/LanguageSelector';
import '../App.css';
import logo from '../assets/logo/fourpusLogo.jpg'
import { Link } from 'react-router-dom';
import Avatar from './Avatar'

export const Navigation = () => {
  const { translate } = useTranslation();

  // localStorage'dan kullanıcı bilgisini al
  const storedUser = localStorage.getItem("googleUser");
  const googleUser = storedUser ? JSON.parse(storedUser) : null;

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(prev => !prev);
  };

  const handleLogout = () => {
    localStorage.removeItem("googleUser");
    localStorage.removeItem("googleToken");
    window.location.reload();
  };

  return (
    <nav id="menu" style={{ backgroundColor: "#f7f7f7" }} className="navbar navbar-default navbar-fixed-top">
      <img className="responsive-logo" src={logo} alt="Fourpus" />
      <div className="container container-navbar">
        <div className="navbar-header">
          <a className="navbar-brand page-scroll" href="#page-top">
            <span className="brand-desktop">{translate('brand_name')}</span>
            <span className="brand-mobile">Fourpus</span>
          </a>
        </div>
         <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">{translate('toggle_navigation')}</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" className="page-scroll" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                {translate('nav_features')}
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                {translate('nav_about')}
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                {translate('nav_services')}
              </a>
            </li>
{/*            <li>
              <a href="#team" className="page-scroll" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                {translate('nav_team')}
              </a>
            </li> */}
            <li>
              <a href="#contact" className="page-scroll" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                {translate('nav_contact')}
              </a>
            </li>
            <li>
              <div className="mobile-language-selector">
                <LanguageSelector />
              </div>
            </li>
          </ul>
        </div>
      </div>
      {/*<div style={{marginLeft:"-40px"}}>|</div>
      <div className="language-selector-wrapper" style={{ position: 'relative' }}>
        {!googleUser ? (
          <Link to="/login">{translate('login')}</Link>
        ) : (
          <div style={{ cursor: "pointer", display: "flex", alignItems: "center" }} onClick={toggleDropdown}>
            <Avatar name={googleUser.name} />
            <span style={{ marginLeft: 8 }}>{googleUser.name}</span>

            {dropdownOpen && (
              <div
                style={{
                  position: "absolute",
                  right: 0,
                  top: "calc(100% + 5px)",
                  backgroundColor: "#fff",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                  borderRadius: 4,
                  minWidth: 150,
                  zIndex: 1000,
                  padding: 8
                }}
              >
                <button
                  onClick={handleLogout}
                  style={{
                    background: "none",
                    border: "none",
                    padding: "8px 12px",
                    width: "100%",
                    textAlign: "left",
                    cursor: "pointer"
                  }}
                >
                  Çıkış Yap
                </button>
              </div>
            )}
          </div>
        )}
      </div> */}

      <div className="language-selector-wrapper">
        <LanguageSelector />
      </div>
    </nav>
  );
};
